import { callApi } from '@/api/api-core'

export const myUser = function(redirectOnUnauthorized = true) {
    return callApi('GET', 'api/myuser/profile', undefined, undefined, undefined, undefined, undefined, redirectOnUnauthorized)
}
